<script setup lang="ts">
defineExpose({
  name: "RadioOffIcon",
});
</script>

<template>
  <svg
    class="RadioOffIcon"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      class="RadioOffIcon__inner"
      cx="12"
      cy="12"
      r="7.375"
      stroke-width="1.25"
    />
  </svg>
</template>

<style lang="scss" scoped>
.RadioOffIcon {
  width: 100%;
  height: auto;

  &__inner {
    stroke: currentcolor;
  }
}
</style>
